import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { LocalStorage,LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { ExaminationModel } from 'src/app/models/ExaminationModel';
import { ExaminationService } from 'src/app/services/ExaminationService';
import { PatientModel } from 'src/app/models/PatientsModel';
import { ExaminationsearchComponent } from '../examinationsearch/examinationsearch.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ExAttachViewComponent } from '../ex-attach-view/ex-attach-view.component';


@Component({
  selector: 'app-examination',
  templateUrl: './examination.component.html',
  styleUrls: ['./examination.component.css'],
})
export class examinationComponent implements OnInit {
patintname = '';
bloodSugarFasting= '0';
bloodSugarRandom= '0';
cBcHgb= '0';
cBcMcH= '0';
cBcMcV= '0';
cBcPlT= '0';
cBcTlc= '0';
compcode= '1';
dateentry= formatDate(new Date(), 'yyyy-MM-dd', 'en');
diftBaso= '';
difteosino= '';
diftlym= '';
diftMono= '';
diftNeu= '';
electroca1= '0';
electroca2= '0';
electroeSR1hr= '0';
electroeSR2hr= '0';
electrok= '0';
electroNa= '0';
kFTScrea= '0';
kFTUrea= '0';
kFTUricAcid= '0';
lFTAlB= '0';
lFTAlkPH= '0';
lFTAlT_SGPT= '0';
lFTAST_SGoT= '0';
lFTdBill= '0';
lFTGGT= '0';
lFTINR= '0';
lFTldH= '0';
lFTPc= '0';
lFTPT= '0';
lFTTBill= '0';
modifieddate= formatDate(new Date(), 'yyyy-MM-dd', 'en');
other1= '';
other2= '';
other3= '';
other4= '';
other5= '';
other6= '';
other7= '';
other8= '';
other9= '';
patientcode= '';
tMarkersAFP= '';
tMarkerscA12_5= '';
tMarkerscA15_3= '';
tMarkerscA19_9= '';
tMarkersceA= '';
tMarkersPSA= '';
userId= 'sa';
paName = '';
imageSrc;
imageSource: any;
myimage :any;


  sellersPermitFile: any;
  sellersPermitString = '';
constructor(
    public dataBankService: DataBankService,
    public dataBankModel: DatabankModel,
    private dialogref: MatDialog,
    public patientmodel:PatientModel,
    public storage: LocalStorageService,
    public examinationModel: ExaminationModel,
    public examinationService:ExaminationService,
    public examinationSelectedData:ExaminationModel,
    private sanitizer: DomSanitizer
    ) {}

  ngOnInit(): void {

  }


retivePatinetName(){
  this.dataBankService
      .getPatient(this.patientcode, this.compcode)
      .subscribe((data: DatabankModel) => {
        this.patintname = data.patientFName;
      })
      this.retrieveexamination();
}

retrieveexamination() {
  console.log(" -1--- ",this.patientcode,this.dateentry  ,this.storage.retrieve('stgcompcode'))

    this.examinationService
      .getexamination(this.patientcode,this.dateentry, this.storage.retrieve('stgcompCode'))

      .subscribe((data: ExaminationModel) => {

        this.bloodSugarFasting = data.bloodSugarFasting;
        this.bloodSugarRandom = data.bloodSugarRandom;
        this.cBcHgb = data.cBcHgb;
        this.cBcMcH = data.cBcMcH;
        this.cBcMcV = data.cBcMcV;
        this.cBcPlT = data.cBcPlT;
        this.cBcTlc = data.cBcTlc;
        this.compcode = data.compcode;

        this.diftBaso = data.diftBaso;
        this.difteosino = data.difteosino;
        this.diftlym = data.diftlym;
        this.diftMono = data.diftMono;
        this.diftNeu = data.diftNeu;
        this.electroca1 = data.electroca1;
        this.electroca2 = data.electroca2;
        this.electroeSR1hr = data.electroeSR1hr;
        this.electroeSR2hr = data.electroeSR2hr;
        this.electrok = data.electrok;
        this.electroNa = data.electroNa;
        this.kFTScrea = data.kFTScrea;
        this.kFTUrea = data.kFTUrea;
        this.kFTUricAcid = data.kFTUricAcid;
        this.lFTAlB = data.lFTAlB;
        this.lFTAlkPH = data.lFTAlkPH;
        this.lFTAlT_SGPT = data.lFTAlT_SGPT;
        this.lFTAST_SGoT = data.lFTAST_SGoT;
        this.lFTdBill = data.lFTdBill;
        this.lFTGGT = data.lFTGGT;
        this.lFTINR = data.lFTINR;
        this.lFTldH = data.lFTldH;
        this.lFTPc = data.lFTPc;
        this.lFTPT = data.lFTPT;
        this.lFTTBill = data.lFTTBill;
        this.modifieddate = formatDate(data.modifieddate, 'yyyy-MM-dd', 'en') ;
        this.other1 = data.other1;
        this.other2 = data.other2;
        this.other3 = data.other3;
        this.other4 = data.other4;
        this.other5 = data.other5;
        this.other6 = data.other6;
        this.other7 = data.other7;
        this.other8 = data.other8;
        this.other9 = data.other9;

        this.tMarkersAFP = data.tMarkersAFP;
        this.tMarkerscA12_5 = data.tMarkerscA12_5;
        this.tMarkerscA15_3 = data.tMarkerscA15_3;
        this.tMarkerscA19_9 = data.tMarkerscA19_9;
        this.tMarkersceA = data.tMarkersceA;
        this.tMarkersPSA = data.tMarkersPSA;
        this.userId = data.userId;

        this.myimage = data.exattach;
    this.sellersPermitString =  data.exattach;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;
    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);





      });
    }

ClearexaminationData() {

      this.patintname = '';

      this.bloodSugarFasting ='';
      this.bloodSugarRandom ='';
      this.cBcHgb ='';
      this.cBcMcH ='';
      this.cBcMcV ='';
      this.cBcPlT ='';
      this.cBcTlc ='';
      this.compcode ='';
      this.dateentry =formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.diftBaso ='';
      this.difteosino ='';
      this.diftlym ='';
      this.diftMono ='';
      this.diftNeu ='';
      this.electroca1 ='';
      this.electroca2 ='';
      this.electroeSR1hr ='';
      this.electroeSR2hr ='';
      this.electrok ='';
      this.electroNa ='';
      this.kFTScrea ='';
      this.kFTUrea ='';
      this.kFTUricAcid ='';
      this.lFTAlB ='';
      this.lFTAlkPH ='';
      this.lFTAlT_SGPT ='';
      this.lFTAST_SGoT ='';
      this.lFTdBill ='';
      this.lFTGGT ='';
      this.lFTINR ='';
      this.lFTldH ='';
      this.lFTPc ='';
      this.lFTPT ='';
      this.lFTTBill ='';
      this.modifieddate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.other1 ='';
      this.other2 ='';
      this.other3 ='';
      this.other4 ='';
      this.other5 ='';
      this.other6 ='';
      this.other7 ='';
      this.other8 ='';
      this.other9 ='';
      this.patientcode ='';
      this.tMarkersAFP ='';
      this.tMarkerscA12_5 ='';
      this.tMarkerscA15_3 ='';
      this.tMarkerscA19_9 ='';
      this.tMarkersceA ='';
      this.tMarkersPSA ='';
      this.userId ='';


    }

submitData() {
            this.examinationModel.bloodSugarFasting = this.bloodSugarFasting;
            this.examinationModel.bloodSugarRandom = this.bloodSugarRandom;
            this.examinationModel.cBcHgb = this.cBcHgb;
            this.examinationModel.cBcMcH = this.cBcMcH;
            this.examinationModel.cBcMcV = this.cBcMcV;
            this.examinationModel.cBcPlT = this.cBcPlT;
            this.examinationModel.cBcTlc = this.cBcTlc;
            this.examinationModel.compcode = this.storage.retrieve('stgcompCode')
            this.examinationModel.dateentry = formatDate(this.dateentry, 'yyyy-MM-dd', 'en');
            this.examinationModel.diftBaso = this.diftBaso;
            this.examinationModel.difteosino = this.difteosino;
            this.examinationModel.diftlym = this.diftlym;
            this.examinationModel.diftMono = this.diftMono;
            this.examinationModel.diftNeu = this.diftNeu;
            this.examinationModel.electroca1 = this.electroca1;
            this.examinationModel.electroca2 = this.electroca2;
            this.examinationModel.electroeSR1hr = this.electroeSR1hr;
            this.examinationModel.electroeSR2hr = this.electroeSR2hr;
            this.examinationModel.electrok = this.electrok;
            this.examinationModel.electroNa = this.electroNa;
            this.examinationModel.kFTScrea = this.kFTScrea;
            this.examinationModel.kFTUrea = this.kFTUrea;
            this.examinationModel.kFTUricAcid = this.kFTUricAcid;
            this.examinationModel.lFTAlB = this.lFTAlB;
            this.examinationModel.lFTAlkPH = this.lFTAlkPH;
            this.examinationModel.lFTAlT_SGPT = this.lFTAlT_SGPT;
            this.examinationModel.lFTAST_SGoT = this.lFTAST_SGoT;
            this.examinationModel.lFTdBill = this.lFTdBill;
            this.examinationModel.lFTGGT = this.lFTGGT;
            this.examinationModel.lFTINR = this.lFTINR;
            this.examinationModel.lFTldH = this.lFTldH;
            this.examinationModel.lFTPc = this.lFTPc;
            this.examinationModel.lFTPT = this.lFTPT;
            this.examinationModel.lFTTBill = this.lFTTBill;
            this.examinationModel.modifieddate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
            this.examinationModel.other1 = this.other1;
            this.examinationModel.other2 = this.other2;
            this.examinationModel.other3 = this.other3;
            this.examinationModel.other4 = this.other4;
            this.examinationModel.other5 = this.other5;
            this.examinationModel.other6 = this.other6;
            this.examinationModel.other7 = this.other7;
            this.examinationModel.other8 = this.other8;
            this.examinationModel.other9 = this.other9;
            this.examinationModel.patientcode = this.patientcode;
            this.examinationModel.tMarkersAFP = this.tMarkersAFP;
            this.examinationModel.tMarkerscA12_5 = this.tMarkerscA12_5;
            this.examinationModel.tMarkerscA15_3 = this.tMarkerscA15_3;
            this.examinationModel.tMarkerscA19_9 = this.tMarkerscA19_9;
            this.examinationModel.tMarkersceA = this.tMarkersceA;
            this.examinationModel.tMarkersPSA = this.tMarkersPSA;
            this.examinationModel.userId =  this.storage.retrieve('stgUserId');
            this.examinationModel.paName =  this.paName;
            this.examinationService.Addexamination(this.examinationModel).subscribe(data => {
            this.UpdateEXAttach();
              this.messagesave();

      },

        error => { alert(error); }
      );
    }
UpdateEXAttach(){
      this.examinationModel.patientcode = this.patientcode;
      this.examinationModel.dateentry = formatDate(this.dateentry, 'yyyy-MM-dd', 'en');
      this.examinationModel.exattach = this.sellersPermitString;
      this.examinationModel.userId = this.storage.retrieve('stguserId');
      this.examinationModel.modifieddate= formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.examinationModel.compcode = this.storage.retrieve('stgcompCode')

      this.examinationService.AddExAttach(this.examinationModel).subscribe(data => {
        //console.log(data.userID);

      },

        error => { alert(error); }

      );
    }
  openDialogViwer(){
      const dialogRef = this.dialogref.open(ExAttachViewComponent,
        {
          data: {
            dataKey: this.examinationModel,
            wk_patientcode : this.patientcode,
            wk_dateentry : this.dateentry
          },
          width: '40vw',
      });
      dialogRef.afterClosed().subscribe(result => {
      });
      const dialogSubmitSubscription =
         dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();

        });
    }
    messagesave()
{
  Swal({title:'Saved',type:'success',showConfirmButton:false,timer:1500});
}

openDialog(){
  const dialogRef = this.dialogref.open(PopuppatientsearchComponent,
    {
      data: {
        dataKey: this.patientmodel
      }
  });
  dialogRef.afterClosed().subscribe(result => {
  });

  const dialogSubmitSubscription =
     dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.patientcode = result.patientCode;
      this.patintname = result.patientFName;

      this.retrieveexamination();
      dialogSubmitSubscription.unsubscribe();
    });
}

openDialogC(){
  this.storage.store('stgPaID', this.patientcode);
  console.log(" stgPaID.dateEntry :" , this.storage.retrieve('stgPaID'));

  const dialogRef = this.dialogref.open(ExaminationsearchComponent,
    {
      data: {
        dataKey: this.examinationSelectedData
      }
    });
  dialogRef.afterClosed().subscribe(result => {
  });

    const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.dateentry = formatDate(result.dateentry, 'yyyy-MM-dd', 'en');
      this.retrieveexamination();

      dialogSubmitSubscription.unsubscribe();

    });

}
public picked(event: any) {
  let fileList: FileList = event.target.files;
  if (fileList.length > 0) {
    const file: File = fileList[0];
    this.sellersPermitFile = file;
    this.handleInputChange(file); //turn into base64

  }
  else {
    alert("No file selected");
  }
}
handleInputChange(files: any) {
  var file = files;
  var pattern = /image-*/;
  var reader = new FileReader();
  if (!file.type.match(pattern)) {
    alert('invalid format');
    return;
  }

  reader.onloadend = this._handleReaderLoaded.bind(this);
  reader.readAsDataURL(file);
}
_handleReaderLoaded(e: any) {
  let reader = e.target;
  var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
  this.imageSrc = base64result;
  this.sellersPermitString = base64result;
  this.myimage =this.sellersPermitString;
  var kk = this.sellersPermitString;

  this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);

  console.log("imageSource ## :" + this.imageSource);
}

log() {


  this.myimage =this.sellersPermitString;
  //console.log('1', this.sellersPermitString);
}
}
